// services/sales/CreditNoteBalanceService.ts

import { creditNoteBalanceApi } from "../../api";


const CreditNoteBalanceService = {
  /**
   * GET /api/credit-notes/balances?creditNoteId=...&creditFiscalSaleId=...
   * Devuelve el balance por producto excluyendo los que ya se devolvieron.
   */
  getBalances: async (creditNoteId: number, creditFiscalSaleId: number) => {
    const response = await creditNoteBalanceApi.fetchCustom(
      `?creditNoteId=${creditNoteId}&creditFiscalSaleId=${creditFiscalSaleId}`
    );
    return response.data.data;
  },
};

export default CreditNoteBalanceService;
